import { useEffect } from "react";

export const useOutsideClick = (ref, handler, opened) => {
    useEffect(() => {
        if(!opened) return;

        const handleClick = (e) =>{
            if(!ref.current || ref.current.contains(e.target)) return;
            handler();
        }

        document.addEventListener("mousedown", handleClick);

        return () => {
            document.removeEventListener('mousedown', handleClick);
        }

    }, [ref, handler, opened])

}